import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { StoreModule } from '@ngrx/store';
import { flowFeatureName } from './types';
import { reducers } from './reducers';
import { GungFlowEffects } from './effects';
import { EffectsModule } from '@ngrx/effects';

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    StoreModule.forFeature(flowFeatureName, reducers),
    EffectsModule.forFeature([GungFlowEffects])
  ]
})
export class FlowModule {}
